import { TimeWindowUpdateModal } from '../time-window-update/time-window-update-modal.component';
import { FulfillmentView } from './fulfillment-view/fulfillment-view.component';
import { useFulfillmentServices } from './fulfillment.hooks';

export const Fulfillment = () => {
    const { closeTimeWindowModal, fulfillmentServices, selectedService } = useFulfillmentServices();

    return (
        <>
            <FulfillmentView services={fulfillmentServices} />
            <TimeWindowUpdateModal onClose={closeTimeWindowModal} selectedService={selectedService} />
        </>
    );
};
